<template>
    <div class="grid-item grid-item-half">
        <h3>Allocations</h3>
        <div v-if="!creditMemo.hasAllocations">Credit memo has no invoice allocations.</div>
        <table class="table table-compact" v-else>
            <tbody>
            <tr>
                <th class="width-half">Invoice</th>
                <th class="text-right">Amount</th>
            </tr>
            <tr v-for="allocation in creditMemo.allocations" :key="allocation.invoiceId">
                <td class="width-half">
                    <router-link :to="{name: 'invoice-details', params: {id: allocation.invoiceId}}">
                        Invoice {{invoices.find(invoice => invoice.id === allocation.invoiceId).invoiceNumberLabel}}
                    </router-link>
                </td>
                <td class="text-right is-numeric">
                    {{allocation.credit | monetize(creditMemo.currency)}}
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
    import {mapState} from 'vuex';

    export default {
        computed: {
            ...mapState('creditMemos', ['creditMemo', 'invoices']),
        },
    };
</script>
